export default ['Display Name', 'User Name', 'Enabled', 'Scope', 'Roles', 'Delete'];
